import React from "react";

const ColorModeContext = React.createContext({ toggleColorMode: () => { }, setThemeMode: (mode) => { } });

export default ColorModeContext;